<template>
  <div id="app">

    <header-view class="header"></header-view>

    <router-view class="main"/>

    <footer-view class="footer"></footer-view>

  </div>
</template>

<script>

import HeaderView from '@/components/HeaderView'
import FooterView from '@/components/FooterView'

export default {
  components: {
    HeaderView,
    FooterView
  },
  name: 'App'
}
</script>

<style>

@import url('https://fonts.googleapis.com/css?family=Abril+Fatface:100,300,400,500,700');
@import url('https://fonts.googleapis.com/css?family=Open+Sans:100,300,400,500,700');
@import url('https://fonts.googleapis.com/css?family=Old+Standard+TT:100,300,400,500,700');
@import '/assets/style/layout.css';
@import '/assets/style/flex.css';
@import '/assets/style/text.css';
@import '/assets/style/decoration.css';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  height: auto;
  min-height: 100%;

  display: flex;
  flex-direction: column;

}

.header{
    flex: 1;
}

.main{
  flex: 1;
}

.footer{
    flex: 1;
}

.gray{
  color: gray;
}

</style>



// WEBPACK FOOTER //
// src/App.vue